import {ComparisonDate} from 'common/query-builder/query-block/time-comparison-menu/types';
import {DateRange} from 'common/widgets/date-range-picker/models/date-range';
import {DateRangeType} from 'common/types/reports/bookmark';
// this import is treacherous; a peer widget
import {InlineCohortSegment, SavedCohortSegment, Segment} from 'common/query-builder/query-block/segment-menu/types';
import {LiftType, LiftTypeOverrides, SegmentLiftBaselineOption} from 'common/report/util/lift/types';
import {ResourceType} from 'common/report/constants';

export enum MenuDropdownState {
  List = `list`,
  CustomTime = `time`,
  Baseline = `baseline`,
}

export interface LiftComparisonAttrs {
  'max-data-history-days': number;
  'project-as-of-date': string;
  'selected-date'?: ComparisonDate;
  breakdowns?: Segment[];
  'selected-breakdown-segments'?: SegmentLiftBaselineOption[];
  'disabled-message'?: string;
  'date-range'?: DateRange;
  'selected-lift-comparison'?: LiftComparison;
  'time-comparison-disabled-reason'?: string;
}

export interface LiftComparisonParams {
  liftTypeOverrides: LiftTypeOverrides;
}

export interface LiftComparisonState {
  dropdownState: MenuDropdownState;
  stagedComparisonDate: ComparisonDate;
  stagedComparisonType: DateRangeType.StartsOn | DateRangeType.EndsOn;
  isMenuOpen: boolean;
}

export interface LiftComparison {
  type: LiftType;

  // Used for baseline comparisons; time and overall don't need any other information
  /* The selected cohort for a Baseline/Segment comparison, when the baseline is a Cohort */
  cohort?: SavedCohortSegment[ResourceType.Cohort] | InlineCohortSegment[ResourceType.Cohort];
  /* The selected segment for a Baseline/Segment comparison, when the baseline is a property. Usually a property value */
  groupValue?: string;
  /* A representation of a breakdown. A SegmentType or CohortSegment. */
  comparisonProperty?: any;
}

export interface LiftSelectionEvent {
  liftComparison?: LiftComparison;
  comparisonDateRange?: ComparisonDate;
}

export interface LiftComparisonJsxProps {
  attrs: LiftComparisonAttrs;
  params: LiftComparisonParams;
  on?: {
    remove?: (ev: CustomEvent) => void;
    select?: (ev: CustomEvent<LiftSelectionEvent>) => void;
  };
}
